import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

/**
 * Check whether the current student follows a society / organizer. The
 * backend answers `status: 0` with the record when following and
 * `status: -40001` when not.
 * Backend: GET /api/user/followOrganizer/checkFollowingOrNot
 */
export const CheckFollowingOrganizerOrNotAPI = async (
  organizerId: string,
): Promise<ServiceResponse<unknown>> => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "GET",
      "api/user/followOrganizer/checkFollowingOrNot",
      {
        user_id: user?.id,
        society_id: organizerId,
      },
    );
    return resp;
  } catch (err) {
    console.error(`CheckFollowingOrganizerOrNotAPI ${err}`);
    return { status: -1 };
  }
};

/**
 * Follow (`followStatus === false`) or unfollow (`followStatus === true`) a
 * society / organizer for the current student.
 * Backend: POST /api/user/followOrganizer/followOrganizer
 * Backend: DELETE /api/user/followOrganizer/unfollowOrganizer
 */
export const FollowOrganizerOrNotAPI = async (
  followStatus: boolean,
  organizerId: string,
): Promise<ServiceResponse> => {
  const { user } = store.getState().auth as any;
  try {
    const resp = followStatus
      ? await service.call(
          "DELETE",
          "api/user/followOrganizer/unfollowOrganizer",
          {
            user_id: user?.id,
            society_id: organizerId,
          },
        )
      : await service.call(
          "POST",
          "api/user/followOrganizer/followOrganizer",
          {
            user_id: user?.id,
            society_id: organizerId,
          },
        );
    return resp;
  } catch (err) {
    console.error(`FollowOrganizerOrNotAPI ${err}`);
    return { status: -1 };
  }
};
